import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import OperationsPage from './OperationsPage';

export default flowRight(withVerificationGuard, withAuthGuard())(OperationsPage);
